import React from "react";
import DashboardWrapper from "components/lib/Global/DashboardWrapper";
import Hero from "components/lib/Global/Hero";
import ComplianceTasksBoard from "components/Compliance/ComplianceTasksBoard";
import ComplianceAccessGate from "components/Compliance/ComplianceAccessGate";

const ComplianceTasksPage = () => (
  <DashboardWrapper>
    <ComplianceAccessGate>
      <div className="space-y-8 py-10">
        <Hero
          heading="Registrar Task Hub"
          description="Filter compliance activities by urgency and due window."
        />
        <ComplianceTasksBoard />
      </div>
    </ComplianceAccessGate>
  </DashboardWrapper>
);

export default ComplianceTasksPage;
